<template>
  <c-dialog :return-data="model">
    <c-input v-model="model" autogrow />
  </c-dialog>
</template>

<script setup>
const model = defineModel();
</script>
